/**
 * Classes compartilhadas pelos controles de formulário (Input, Textarea,
 * NumberField, gatilho do Select).
 *
 * Fica em arquivo próprio porque um módulo de componente que exporta constantes
 * quebra o Fast Refresh do Vite.
 */
export const controlBase = [
  "w-full font-ds-sans text-ds-body text-ds-ink-900",
  "bg-ds-surface border border-ds-ink-500 rounded-ds-md",
  "placeholder:text-ds-ink-600",
  "transition-[border-color,box-shadow] duration-150 ease-ds-out",
  "hover:border-ds-border-strong",
  // Anel opaco: a 25% de opacidade ele ficava em ~1,2:1 contra o entorno,
  // longe dos 3:1 que um indicador de foco precisa ter.
  "focus:outline-none focus:border-ds-brand-500 focus:ring-2 focus:ring-ds-focus",
  "disabled:cursor-not-allowed disabled:bg-ds-ink-100 disabled:text-ds-ink-600 disabled:hover:border-ds-ink-500",
  "aria-[invalid=true]:border-ds-danger-700 aria-[invalid=true]:focus:ring-ds-danger-700",
  "motion-reduce:transition-none",
].join(" ");
